// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"_1j7-f0nELAqK_mDbUFDJMv","error":"_2Jgq7ZRztAU3muQTEWkg3P"};